<template>
    <v-layout row wrap class="stores-list">
        <v-flex xs12>
            <v-card v-if="helpAvailable" @click="goToSupport" class="store-list-card" hover flat
                    style="background: transparent">

                <v-card-actions class="pa-2 primary--text text-truncate font-weight-bold">
                    <v-spacer></v-spacer>
                    {{ $vuetify.t('$vuetify.support') }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="goToSupport" class="mr-0">
                        <v-icon color="primary">fal fa-angle-double-right</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-if="termsConditionsAvailable" @click="goToTermsPolicy" class="store-list-card" hover flat
                    style="background: transparent">

                <v-card-actions class="pa-2 primary--text text-truncate font-weight-bold">
                    <v-spacer></v-spacer>
                    {{ $vuetify.t('$vuetify.gdpr_agreement.program_terms_policy') }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="goToTermsPolicy" class="mr-0">
                        <v-icon color="primary">fal fa-angle-double-right</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "InfoOptions",
        data: () => ({
            helpAvailable: false,
            termsConditionsAvailable: false
        }),
        methods: {
            goToSupport() {
                this.$router.push({name: "info-support"});
            },
            goToTermsPolicy() {
                this.$router.push({name: "terms-policy"});
            },
            // @modified ana.castro 2019.12.30 SCLAPP-23
            updateAvailableOptions(state) {
                if (state.configs.helpMenu) {
                    this.helpAvailable = true;
                }
                if (state.configs.termsConditionsMenu) {
                    this.termsConditionsAvailable = true;
                }

            },
        },
        mounted() {
            this.updateAvailableOptions(this.$store.state);
        }
    }
</script>

<style scoped>

</style>